export const ABOUT = '/about';
export const BLOG = '/blog';
export const HOME = '/';
